import classNames from 'classnames'
import * as React from 'react'

import './Tabs.scss'

interface TabProps {
  title?: string
  key?: string
  automation?: string
}

export const Tab: React.SFC<TabProps> = ({ children }) => {
  return children
}

interface TabsProps {
  className?: string
  defaultActive?: string
  automation: string
  activeTab?: string
  setActiveTab?: (activeTab: string) => void
  onChange?: (activeTab: string) => void
  hideSwitchBar?: boolean
  paymentTabRef?: React.RefObject<HTMLDivElement>
}

interface TabsState {
  activeTab: string
}

class Tabs extends React.Component<TabsProps, TabsState> {
  public constructor(props) {
    super(props)
    this.state = { activeTab: props.activeTab || props.defaultActive }
  }

  public render() {
    const {
      className,
      automation,
      activeTab = this.state.activeTab,
      setActiveTab,
      children,
      hideSwitchBar = false,
      paymentTabRef,
    } = this.props
    return (
      <div className={`zervant-tabs ${className}`} data-automation={automation}>
        {!hideSwitchBar && (
          <div className="zervant-tabs-switches">
            {React.Children.map(
              children,
              (child) =>
                child && (
                  <div
                    ref={child?.key === 'paymentDetails' ? paymentTabRef : null}
                    onClick={() => {
                      if (setActiveTab) {
                        setActiveTab(child.key)
                      } else {
                        this.setState({ activeTab: child.key })
                      }
                      if (this.props.onChange) {
                        this.props.onChange(child.key)
                      }
                    }}
                    data-automation={`${automation}-tab-${child.key}`}
                    className={classNames('zervant-tabs-switch', `tabs-switch-${child.key}`, {
                      'active-tab': activeTab === child.key,
                    })}
                  >
                    {child.props.title}
                  </div>
                ),
            )}
          </div>
        )}
        <div className="zervant-tabs-content-wrap">
          {React.Children.map(
            children,
            (child) =>
              child && (
                <div
                  className="zervant-tabs-content"
                  data-automation={`${automation}-tab-content-${child.key}`}
                  style={child.key === activeTab ? {} : { display: 'none' }}
                >
                  {child}
                </div>
              ),
          )}
        </div>
      </div>
    )
  }
}

export default Tabs
